<template>
    <section class="app-card">
        <div v-if="title || $slots.actions" class="app-card__header">
            <div class="app-card__heading">
                <div class="app-card__title-row">
                    <slot name="icon" />
                    <h2 class="app-card__title">{{ title }}</h2>
                </div>
                <p v-if="description" class="app-card__desc">{{ description }}</p>
            </div>
            <slot name="actions" />
        </div>
        <slot />
    </section>
</template>

<script>
// Page content card with an optional header.
//   <app-card :title="$t('bank.title')" :description="$t('bank.description')">
//       <template #icon><svg .../></template>
//       <template #actions><button .../></template>
//       ...content
//   </app-card>
export default {
    name: 'AppCard',
    props: {
        title: { type: String, default: '' },
        description: { type: String, default: '' }
    }
};
</script>

<style lang="scss" scoped>
.app-card {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 24px 20px;
    border-radius: 16px;
    border: 1px solid var(--border-subtle);
    background: linear-gradient(179deg, var(--surface-card) 20%, var(--surface-0) 54%);
}

.app-card__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.app-card__heading {
    flex: 1;
    min-width: 0;
}

.app-card__title-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.app-card__title {
    color: var(--text-main);
    font-size: 20px;
    font-weight: 800;
    font-family: 'Urbanist', sans-serif;
    line-height: 32px;
    margin: 0;
}

.app-card__desc {
    color: var(--text-muted);
    font-size: 14px;
    font-weight: 400;
    font-family: 'Urbanist', sans-serif;
    line-height: 20px;
    margin: 4px 0 0;
}
</style>
